import React, { FC } from 'react';
import { WithStyle } from '@ch/common/utils';
import { ErrorProps } from './types';
import { FormErrorStyled } from './error.styled';

export const FormError: FC<ErrorProps> & WithStyle = ({ children, ...rest }) => {
  return (
    <FormErrorStyled {...rest}>
      <span>{children}</span>
    </FormErrorStyled>
  );
};

FormError.displayName = 'FormError';
FormError.Style = FormErrorStyled;
